<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12" style="margin-top: -35px;">
        <v-img :src="require('../assets/logo.jpg')" class="my-3" contain max-height="300" />
      </v-col>

      <v-col style="margin-top: -60px;" class="d-flex justify-center">
        <v-row style="max-width: 600px;" class="pl-4 pr-4">
          <v-btn
            v-for="(btn,i) in btns"
            :key="i"
            block
            class="mb-4"
            :color="btn.color"
            height="65"
            :href="btn.href"
            @mouseover="btn.color = 'white'"
            @mouseout="btn.color = '#A60600'"
          >
            <span
              :style="btn.color === '#A60600' ? 'color: white;' : 'color: #A60600;'"
            >{{btn.title}}</span>
          </v-btn>
          <v-row class="mt-6">
            <v-spacer></v-spacer>
            <h2
              style="color:white; text-align:center; font-size:1.3em;"
            >Doe Medula Óssea! Doe Vida! Doe Amor!</h2>
            <v-spacer></v-spacer>
          </v-row>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HelloWorld",

  data: () => ({
    btns: [
      {
        title: "Instagram",
        href: "https://instagram.com/flamedula?igshid=cf5vogojuqo5",
        color: "#A60600",
      },
      {
        title: "Facebook",
        href: "https://www.facebook.com/consuladoflamedula/",
        color: "#A60600",
      },
      {
        title: "Youtube",
        href: "https://www.youtube.com/channel/UCIhU4AFETd5kwiCOeamcd-A",
        color: "#A60600",
      },
      {
        title: "Whatsapp",
        href:
          "https://api.whatsapp.com/send?phone=5585999280682&text=Enviar%20mensagem",
        color: "#A60600",
      },
      {
        title: "Twitter",
        href: "https://twitter.com/FlaMedula",
        color: "#A60600",
      },
    ],
  }),
};
</script>
